import { gql } from '@apollo/client'

export default gql`
  mutation SignRelicApostleManagement($input: [RelicApostleManagementInput!]) {
    signRelicApostleManagement(input: $input) {
      signature
      timestamp
      managementPayloads {
        actions
        apostleIDs
        createTimes
        genes
        iVs
        planetID
        seedPlanetID
        slotsWithApostleIDs
      }
    }
  }
`
